import React from 'react';
import { MessageSquare } from 'lucide-react';
import type { ProjectFile } from '../../types';
import { projectFileSupportsCommentPins } from '../../utils/projectFileService';

interface ProjectFileCommentsButtonProps {
  file: ProjectFile;
  /** Unread pin + reply count for the current user. */
  commentCount: number;
  hasUnread: boolean;
  onOpen: () => void;
}

/** Comment button: red unread count only. Hidden number when the user is caught up. */
const ProjectFileCommentsButton: React.FC<ProjectFileCommentsButtonProps> = ({
  file,
  commentCount,
  hasUnread,
  onOpen,
}) => {
  if (!projectFileSupportsCommentPins(file)) return null;

  const unreadCount = hasUnread ? commentCount : 0;
  const label =
    unreadCount > 0
      ? `${unreadCount} unread comment${unreadCount !== 1 ? 's' : ''}`
      : 'View or add comments';

  return (
    <button
      type="button"
      className={`pf-icon-btn pf-comment-btn${unreadCount > 0 ? ' pf-comment-btn--has-unread' : ''}`}
      onClick={e => {
        e.stopPropagation();
        onOpen();
      }}
      title={label}
      aria-label={label}
    >
      <MessageSquare size={13} strokeWidth={unreadCount > 0 ? 2.25 : 2} />
      {unreadCount > 0 && (
        <span className="pf-comment-count-badge" aria-hidden>
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};

export default ProjectFileCommentsButton;
